import { render, staticRenderFns } from "./ChancelleryCounters.vue?vue&type=template&id=22cf3004&"
import script from "./ChancelleryCounters.vue?vue&type=script&lang=js&"
export * from "./ChancelleryCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports